export default __webpack_public_path__ + "static/media/06_eye.8abbe786.webp";